import type { FC } from 'react';

import type { IconProps } from './type';

export const ClubCurrencyFilledIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M21.602 43.913c11.874 0 21.5-9.626 21.5-21.5s-9.626-21.5-21.5-21.5c-11.875 0-21.5 9.626-21.5 21.5s9.625 21.5 21.5 21.5Zm13.02-16.115v-3.963l-5.546 2.498V17.62l5.54-2.499v-3.962l-9.509 4.286v12.678l-3.509 1.584-3.514-1.584V15.444l-9.51-4.287v3.963l5.547 2.499v8.714l-5.547-2.498v3.963l13.024 5.87 13.025-5.87Z"
        fill="#12EEB1"
        fillRule="evenodd"
      />
    </svg>
  );
};
